export default {"src":"/kelp/_next/static/media/app_header_kernel_logo.9b3621b2.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};